import Home from "./lessons";

export default Home;